import { render, staticRenderFns } from "./orderflow.vue?vue&type=template&id=3240ac08&scoped=true"
import script from "./orderflow.vue?vue&type=script&lang=js"
export * from "./orderflow.vue?vue&type=script&lang=js"
import style0 from "./orderflow.vue?vue&type=style&index=0&id=3240ac08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3240ac08",
  null
  
)

export default component.exports